import React, { useState, useEffect } from 'react';
import axios from 'axios';
// import logo from '../../pages/img/header_logo.svg';        
// import theme_switcher from '../../pages/img/black_theme.svg';
import bell from '../../../pages/client/client_assets/img/bell.svg';        
import stop from '../../../pages/client/client_assets/img/stop.svg';    
// import user_manual from '../../pages/img/user_manual.svg';    
// import user_management from '../../pages/img/user_management.svg';    
// import user_support from '../../pages/img/support.svg';    
import { useNavigate, useLocation } from 'react-router-dom';
import config from '../../../../src/config/config.js';

import Dropdown from 'react-bootstrap/Dropdown';
import Modal from 'react-bootstrap/Modal';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { Avatar, Badge } from 'antd';

import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Header = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const [show, setShow] = useState(false);
    const [userData, setUserData] = useState({}); // Holds user data
    const [language, setLanguage] = useState('English'); // Default language
    const [unreadNotifications, setUnreadNotifications] = useState([]);
    const [unreadCount, setUnreadCount] = useState(0);

    const [name, setName] = useState('');
    const [role, setRole] = useState('');
    const [email, setEmail] = useState('');
    const [profilePicture, setProfilePicture] = useState(null);

    const [loading, setLoading] = useState(true);  // New loading state

    useEffect(() => {
        const fetchUserData = async () => {
            try {
                const response = await axios.get(`${config.API_BASE_URL}/get-user-data-account1.php`, {
                    withCredentials: true, // Ensure the credentials (cookies) are sent
                });
        
                console.log('User data response:', response.data);
        
                if (response.data.success) {
                    setName(response.data.data || '');
                    setRole(response.data.role || '');
                    setEmail(response.data.email || '');
                    setProfilePicture(response.data.profile_picture || '');
                } else {
                    navigate('/client'); // Redirect if user not authenticated
                    console.error('Error fetching user data:', response.data.message);
                }
            } catch (error) {
                console.error('Error fetching user data:', error.response?.data?.message || error.message);
            }
        };
        
    
        fetchUserData();
    }, [navigate]);
    


    

    useEffect(() => {
        const fetchNotifications = async () => {
            try {
                const response = await axios.get(`${config.API_BASE_URL}/get-user-notifications.php`, {
                    withCredentials: true,
                });

                if (response.data.success) {
                    setUnreadNotifications(response.data.notifications || []);
                    setUnreadCount(response.data.unreadCount || 0);
                } else {
                    console.error('Error fetching notifications:', response.data.message);
                }
            } catch (error) {
                console.error('Error fetching notifications:', error.message);
            }
        };

        fetchNotifications();
    }, []);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const displayName = name || 'BYB';
    const profileInitial = typeof name === 'string' && name.length > 0 ? name.charAt(0).toUpperCase() : 'B';


    const handleMarkAllAsRead = async () => {
        console.log('Mark all as read clicked');
        
        try {
            const response = await axios.post(`${config.API_BASE_URL}/user-notifications-read.php`, {}, { withCredentials: true });
            if (response.data.success) {
                setUnreadNotifications([]); // Clear the notifications
                setUnreadCount(0); // Reset unread count
                // toast.success('All notifications marked as read.');
                const initialColors = response.data.notifications.reduce((acc, notification) => ({
                    ...acc,
                    [notification.id]: '#79b4ff2b'  // default blueish background
                }), {});
                setNotificationColors(initialColors);
            } else {
                // toast.error('Failed to mark notifications as read.');
                console.error('Failed to mark notifications as read');

            }
        } catch (error) {
            console.error('Error marking notifications as read:', error.message);
            // toast.error('Error marking notifications as read.');
        }
    };

    // Prevent the component from rendering until data is loaded
    // if (loading) {
    //     return <div>Loading...</div>; // Show a loading indicator or spinner
    // }

    const initialColors = unreadNotifications.reduce((acc, notification) => ({
        ...acc,
        [notification.id]: '#79b4ff2b'  // default blueish background
    }), {});

 const [notificationColors, setNotificationColors] = useState(initialColors);

 const removeColorHandle = (id) => {
    setNotificationColors(prevColors => ({
        ...prevColors,
        [id]: '#fff'  // change to white on click
    }));
};
    
    return (
        <nav className="navbar bg-white topbar mb-4 static-top">
            <button id="sidebarToggleTop" className="btn btn-link d-md-none rounded-circle mr-3">
                <i className="fa fa-bars"></i>
            </button>

            <div className="top_header">
                <div className="theme_switch" onClick={handleShow}>
                    <img src={bell} alt="Notifications" />
                    <Badge count={unreadCount}>
                        <Avatar shape="circle" size="large" />
                    </Badge>
                </div>

                <div className="profile">
                    <Dropdown>
                        <Dropdown.Toggle variant="success" id="dropdown-basic" className="border-0">
                            <div className="pro-img profile_photo">
                                {profilePicture ? (
                                    <img src={`${config.API_BASE_URL}/uploads/${profilePicture}`} alt="Profile" />
                                ) : (
                                    <span>{profileInitial}</span>
                                )}
                            </div>

                            <div className="profile_detail">
                                <p>{displayName}</p>
                                <span>{role || 'Admin'}</span>
                            </div>

                            <div className="down_arrow">
                                {/* Optional arrow icon */}
                            </div>
                        </Dropdown.Toggle>
                    </Dropdown>
                </div>

                <Modal show={show} onHide={handleClose} backdrop="static" className="notification_modal">
                    <Modal.Header closeButton>
                        <div className="notiy_title">
                            <h5>Notifications</h5>
                            <p>Stay updated with your latest notifications</p>
                        </div>
                    </Modal.Header>

                                    <div className='notify_check' >
                                            <span className='nav-link' role="button" onClick={handleMarkAllAsRead}>Mark all as reads</span>
                                    </div>

                    {unreadNotifications.filter((notification) => notification.read_notif === 0).length === 0 ? (
                                <p className='no_unread' >No unread notifications.</p>
                            ) : (
                                unreadNotifications.filter((notification) => notification.read_notif === 0).map((notification) => (
                                    
                                    <div key={notification.id} className="notify_content " role="button" 
                                  style={{ backgroundColor: notificationColors[notification.id] }}
                         onClick={() => removeColorHandle(notification.id)}>
                                        <img src={stop} alt="Notification" />
                                        <div className="stay_notify">
                                            <p className="mb-0">{notification.notification_text}</p>
                                            <span>{new Date(notification.created_at).toLocaleString('en-GB', {
                                                weekday: 'short',
                                                year: 'numeric',
                                                month: 'short',
                                                day: 'numeric',
                                                hour: '2-digit',
                                                minute: '2-digit',
                                                hour12: true,
                                            })}</span>
                                        </div>
                                    </div>
                                ))
                            )}
                    {/* <Tabs defaultActiveKey="All" id="uncontrolled-tab-example" className="mb-3 border-0 notify_check"> */}
                        {/* <Tab eventKey="All" title="All">
                            {unreadNotifications.length === 0 ? (
                                <p>No notifications available.</p>
                            ) : (
                                unreadNotifications.map((notification) => (
                                    <div key={notification.id} className="notify_content">
                                        <img src={stop} alt="Notification" />
                                        <div className="stay_notify">
                                            <p className="mb-0">{notification.notification_text}</p>
                                            <span>{new Date(notification.created_at).toLocaleString('en-GB', {
                                                weekday: 'short',
                                                year: 'numeric',
                                                month: 'short',
                                                day: 'numeric',
                                                hour: '2-digit',
                                                minute: '2-digit',
                                                hour12: true,
                                            })}</span>
                                        </div>
                                    </div>
                                ))
                            )}
                        </Tab> */}
                        {/* <Tab eventKey="MarkAllReads" title={<span>Mark all as reads <span className='count_number'>{unreadCount}</span></span>}> */}
                        {/* <Tab eventKey="MarkAllReads" title={'Mark all as reads'}> */}

                            {/* {unreadNotifications.filter((notification) => notification.read_notif === 0).length === 0 ? (
                                <p>No unread notifications.</p>
                            ) : (
                                unreadNotifications.filter((notification) => notification.read_notif === 0).map((notification) => (
                                    
                                    <div key={notification.id} className="notify_content " role="button" 
                                  style={{ backgroundColor: notificationColors[notification.id] }}
                         onClick={() => removeColorHandle(notification.id)}>
                                        <img src={stop} alt="Notification" />
                                        <div className="stay_notify">
                                            <p className="mb-0">{notification.notification_text}</p>
                                            <span>{new Date(notification.created_at).toLocaleString('en-GB', {
                                                weekday: 'short',
                                                year: 'numeric',
                                                month: 'short',
                                                day: 'numeric',
                                                hour: '2-digit',
                                                minute: '2-digit',
                                                hour12: true,
                                            })}</span>
                                        </div>
                                    </div>
                                ))
                            )} */}
                        {/* </Tab> */}
                        {/* <Tab eventKey="MarkAllRead"  title="Mark all as reads">
                            <div onClick={handleMarkAllAsRead} className="last_marked" >
                                <span >Mark all as reads</span>
                            </div>
                            
                        </Tab> */}
                        {/* <Tab eventKey="MarkAllReads" title={'Mark all as reads'}></Tab>
                    </Tabs> */}
                </Modal>
            </div>

            <ToastContainer />
        </nav>
    );
};

export default Header;
